import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tabs } from "antd";
import { observer } from "mobx-react";
import { useNavigate, useParams } from "react-router-dom";
import { ConsentTable } from "./list/table.js";
import { ShortcodeCards } from "./shortcode/cards.js";
import { StatsGrid } from "./stats/grid.js";
import { __ } from "../../../utils/i18n.js";
import { ConfigContent } from "../content.js";
import { ConfigHintModal } from "../hintModal.js";
const ConsentTabRouter = observer(()=>{
    const tab = useParams().tab || "";
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsx(Tabs, {
        defaultActiveKey: tab,
        onChange: (key)=>{
            navigate(`/consent/${key}`);
        },
        items: [
            {
                key: "",
                label: __("Statistics"),
                children: /*#__PURE__*/ _jsx(ConfigContent, {
                    maxWidth: "fixed",
                    style: {
                        paddingTop: 0
                    },
                    children: /*#__PURE__*/ _jsx(StatsGrid, {})
                })
            },
            {
                key: "list",
                label: __("List of consents"),
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ConsentTable, {}),
                        /*#__PURE__*/ _jsx(ConfigHintModal, {
                            identifier: "list-of-consents"
                        })
                    ]
                })
            },
            {
                key: "legal",
                label: __("Legal links"),
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ShortcodeCards, {}),
                        /*#__PURE__*/ _jsx(ConfigHintModal, {
                            identifier: "shortcodes"
                        })
                    ]
                })
            }
        ]
    });
});
export { ConsentTabRouter };
